import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { scoreLoadingTrue, updatePostingDataReset } from '../../redux/reducers/playersReducer';

const ScoreDeleteModal = ({ scoreDeleteLoading, setScoreDeleteModal, handleDelScore }) => {

  const dispatch = useDispatch()

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Enter') {
        handleDelScore();
        dispatch(scoreLoadingTrue());
        dispatch(updatePostingDataReset());
      } else if (event.key === 'Escape') {
        setScoreDeleteModal(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [dispatch, handleDelScore, setScoreDeleteModal]);

  return (
    <div className="w-full  justify-center items-center absolute top-0 right-0 left-0 bottom-0 flex">
      <div className="max-w-[300px] w-full bg-[#ffff] shadow-md  rounded  p-5">
        <p className="font-bebas text-xl text-center text-black">
          {scoreDeleteLoading
            ? "deleting"
            : "deleting a score is irreversible"}
        </p>
        {!scoreDeleteLoading && (
          <div className="flex justify-center items-center gap-10 mt-10">
            <button
              className="max-w-[48px] rounded h-[30px] w-full bg-black   font-bebas text-lg text-white "
              onClick={() => setScoreDeleteModal(false)}
            >
              No
            </button>
            <button
              className="max-w-[48px] rounded h-[30px] w-full bg-primary font-bebas text-lg text-white"
              onClick={() => {
                handleDelScore();
                dispatch(scoreLoadingTrue());
                dispatch(updatePostingDataReset());
              }}
            >
              Yes
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ScoreDeleteModal;